import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import { post } from '../Services/http';
import { catchError } from './Error.action';

export const ORGANIZATION_SEARCH_QUERY = 'ORGANIZATION_SEARCH_QUERY';
export const ORGANIZATION_SEARCH_RECEIVE = 'ORGANIZATION_SEARCH_RECEIVE';
export const ORGANIZATION_SEARCH_ERROR = 'ORGANIZATION_SEARCH_ERROR';
export const ORGANIZATION_SEARCH_SHOW_FULL_FORM =
    'ORGANIZATION_SEARCH_SHOW_FULL_FORM';
export const ORGANIZATION_SEARCH_SELECT_ITEM =
    'ORGANIZATION_SEARCH_SELECT_ITEM';

let abortController;

export const query = q => (dispatch, getState) => {
    // abort any existing, pending request.
    // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
    abortController && abortController.abort();
    abortController = new AbortController();
    return post('/api/organizationsearch', q, abortController)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => searchError(error))));
};

export const selectOrganization =
    (selectedOrganization, redirectUrl) => dispatch => {
        return post('/api/organizationsearch/selectorganization', {
            selectedOrganization,
            redirectUrl,
        })
            .then(() => {
                window.location = redirectUrl;
            })
            .catch(ex => dispatch(catchError(ex, error => searchError(error))));
    };

export const setSearchQuery = query => ({
    type: ORGANIZATION_SEARCH_QUERY,
    payload: {
        query,
    },
});

export const searchError = error => ({
    type: ORGANIZATION_SEARCH_ERROR,
    payload: {
        error,
    },
});

export const receive = result => ({
    type: ORGANIZATION_SEARCH_RECEIVE,
    payload: {
        result,
        showResult: result && result.length > 0,
    },
});
